import React, { useState } from "react";
import {
  Mail,
  User,
  Phone,
  MessageSquare,
  Home,

  
} from "lucide-react";
import { useTranslation } from "react-i18next";

const CreatePropertyForm = ({ property }) => {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  
  });
  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMsg(null);

    try {
      const payload = {
        ...formData,
        property_id: property?.property_id,
        property_name: property?.name,
      };

      const res = await fetch(
        "https://summerhousagentlive.onrender.com/api/contact",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const data = await res.json();

      if (!res.ok) throw new Error(data.message || "เกิดข้อผิดพลาด");

      setResponseMsg(data.message || "ส่งฟอร์มสำเร็จ");
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
   
      });
    } catch (error) {
      console.error(error);
      setResponseMsg(error.message || "ไม่สามารถส่งฟอร์มได้");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "20vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
        fontFamily: "'Roboto Condensed', 'Kanit', sans-serif",
      }}
    >
      <div
        style={{
          width: "400px",
          backgroundColor: "#fff",
          borderRadius: "16px",
          boxShadow: "0 8px 25px rgba(0,0,0,0.2)",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div
          style={{
            background: "linear-gradient(135deg, #1d3557, #457b9d)",
            color: "white",
            padding: "20px",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              fontSize: "1.8rem",
              fontWeight: "700",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <Mail size={24} /> {t("form.contact_us")}
          </h2>
          <p style={{ marginTop: "5px", fontSize: "0.9rem", color: "#d1d5db" }}>
            {t("form.subtitle")}
          </p>
        </div>

        {/* Property Info */}
        {property && (
          <div
            style={{
              padding: "10px 20px",
              backgroundColor: "#f9fafb",
              borderBottom: "1px solid #e5e7eb",
            }}
          >
            <p
              style={{
                fontSize: "0.9rem",
                color: "#1f2937",
                marginBottom: "4px",
              }}
            >
              <Home size={16} style={{ marginRight: "5px" }} />
              <strong>{t("Property")}:</strong> {property.name || "-"}
            </p>
            <p style={{ fontSize: "0.9rem", color: "#374151" }}>
              <strong>{t("SHA ID")}:</strong> {property.property_id || "-"}
            </p>
          </div>
        )}

        {/* Form */}
        <form
          onSubmit={handleSubmit}
          style={{
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "15px",
          }}
        >
          {/* Name */}
          <div style={styles.inputGroup}>
            <User size={20} style={styles.icon} />
            <input
              type="text"
              name="name"
              placeholder={t("form.name")}
              value={formData.name}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>

          {/* Email */}
          <div style={styles.inputGroup}>
            <Mail size={20} style={styles.icon} />
            <input
              type="email"
              name="email"
              placeholder={t("form.email")}
              value={formData.email}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>

          {/* Phone */}
          <div style={styles.inputGroup}>
            <Phone size={20} style={styles.icon} />
            <input
              type="text"
              name="phone"
              placeholder={t("form.phone")}
              value={formData.phone}
              onChange={handleChange}
              style={styles.input}
            />
          </div>

        

       

          {/* Message */}
          <div style={styles.textAreaGroup}>
            <MessageSquare size={20} style={styles.icon} />
            <textarea
              name="message"
              placeholder={t("form.message")}
              value={formData.message}
              onChange={handleChange}
              required
              rows="4"
              style={styles.textarea}
            />
          </div>

          {/* Submit */}
          <button type="submit" disabled={loading} style={styles.submitButton}>
            {loading ? t("form.sending") : t("form.send_message")}
          </button>
        </form>

        {responseMsg && (
          <p
            style={{ textAlign: "center", padding: "15px", color: "#374151" }}
          >
            {responseMsg}
          </p>
        )}
      </div>
    </div>
  );
};

const styles = {
  inputGroup: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#f3f4f6",
    padding: "10px 15px",
    borderRadius: "12px",
    boxShadow: "inset 0 2px 5px rgba(0,0,0,0.05)",
  },
  textAreaGroup: {
    display: "flex",
    alignItems: "flex-start",
    backgroundColor: "#f3f4f6",
    padding: "10px 15px",
    borderRadius: "12px",
    boxShadow: "inset 0 2px 5px rgba(0,0,0,0.05)",
  },
  icon: {
    marginRight: "10px",
    color: "#3b82f6",
  },
  input: {
    border: "none",
    outline: "none",
    background: "transparent",
    flex: 1,
    fontSize: "1rem",
  },
  textarea: {
    border: "none",
    outline: "none",
    background: "transparent",
    flex: 1,
    fontSize: "1rem",
    resize: "none",
  },
  submitButton: {
    background: "linear-gradient(135deg, #1d3557, #457b9d)",
    color: "white",
    fontWeight: "600",
    padding: "12px",
    borderRadius: "12px",
    fontSize: "1rem",
    cursor: "pointer",
    boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
    transition: "all 0.3s ease",
  },
};

export default CreatePropertyForm;
